<template>
  <div class="animated fadeIn">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'AdminIndex'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Index.vue?4e0f83ca